import React from "react"
import './PageBodyWrapper.css'

const PageBodyWrapper = (props) => {
    return (
        <div className="default-body-wrapper">
            {props.children}
        </div>
    )
}

export default PageBodyWrapper